export default __webpack_public_path__ + "static/media/KOD0113-min.d7783d02.webp";